import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import { isBrowser } from '../../utils/';
import HtmlToReact from 'html-to-react';

const RegisterForm = ({ user, actions, submitFunction }) => {
    const [state, setState] = useState({
        ...user.player,
        optin1: user.player.optin1,
        optin2: user.player.optin2,
        errors: user.errors ? user.errors : '',
    });

    useEffect(() => {
        if (isBrowser() && user.success) {
            navigate('/register_success');
            actions.userActions.clearErrors();
        }

        setState({
            ...user.player,
            optin1: user.player.optin1,
            optin2: user.player.optin2,
            errors: user.errors ? user.errors : '',
        });
    }, [user]);

    const handleUpdate = async event => {
        event.preventDefault();
        submitFunction(state);
    };

    // if the form field changes, we will change the value in the store and
    const handleChange = event => {
        const target = event.target;
        const value =
            target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        setState({
            ...state,
            [name]: value,
        });
    };

    const Parser = HtmlToReact.Parser();

    const error = () => {
        var errors = state.errors.split(/<br\/>/g).filter(item => {
            return item.length > 0;
        });

        if (state.errors) {
            return (
                <div className="alert alert-danger text-center" role="alert">
                    {errors.map(err => {
                        return <div key={err}>{Parser.parse(err)}</div>;
                    })}
                </div>
            );
        }
    };

    return (
        <div className="register-form">
            <div id="register-target" className="">
                {error()}

                <div className="content-data">
                    <form
                        name="user_profile"
                        id="user_profile"
                        onSubmit={handleUpdate}
                        method="post"
                        encType="application/x-www-form-urlencoded"
                    >
                        <input
                            type="hidden"
                            id="form_submitted"
                            name="form_submitted"
                            value="1"
                        />
                        <input type="hidden" id="new" name="new" value="1" />
                        <input
                            type="hidden"
                            id="country"
                            name="country"
                            value="US"
                        />
                        <div>
                            <div className="row">
                                <div className="col-xs-12 col-sm-6">
                                    <div className="form-group">
                                        <label
                                            htmlFor="first_name"
                                            className="control-label"
                                        >
                                            <strong>First Name</strong>
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                id="first_name"
                                                name="first_name"
                                                value={state.first_name}
                                                onChange={handleChange}
                                                size="30"
                                                maxLength="60"
                                                required="true"
                                                className="form-control input-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="form-group">
                                        <label
                                            htmlFor="last_name"
                                            className="control-label"
                                        >
                                            <strong>Last Name</strong>
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                id="last_name"
                                                name="last_name"
                                                value={state.last_name}
                                                onChange={handleChange}
                                                size="30"
                                                maxLength="60"
                                                required="true"
                                                className="form-control input-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="form-group">
                                        <label
                                            htmlFor="email"
                                            className="control-label"
                                        >
                                            <strong>Email Address</strong>
                                        </label>
                                        <div>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={state.email}
                                                onChange={handleChange}
                                                size="30"
                                                maxLength="120"
                                                required="true"
                                                className="form-control input-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="form-group">
                                        <label
                                            htmlFor="email_confirm"
                                            className="control-label"
                                        >
                                            <strong>
                                                Confirm Email Address
                                            </strong>
                                        </label>
                                        <div>
                                            <input
                                                type="email"
                                                id="email_confirm"
                                                name="email_confirm"
                                                value={state.email_confirm}
                                                onChange={handleChange}
                                                size="30"
                                                maxLength="120"
                                                required="true"
                                                className="form-control input-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="address1">
                                            <strong>Address</strong>
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                id="address1"
                                                name="address1"
                                                value={state.address1}
                                                onChange={handleChange}
                                                size="30"
                                                maxLength="60"
                                                required="true"
                                                className="form-control input-sm"
                                            />
                                            <br />
                                            <input
                                                type="text"
                                                id="address2"
                                                name="address2"
                                                value={state.address2}
                                                onChange={handleChange}
                                                size="30"
                                                maxLength="60"
                                                className="form-control input-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-sm-6">
                                    <div className="form-group">
                                        <label
                                            htmlFor="city"
                                            className="control-label"
                                        >
                                            <strong>City</strong>
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                id="city"
                                                name="city"
                                                value={state.city}
                                                onChange={handleChange}
                                                size="30"
                                                maxLength="60"
                                                required="true"
                                                className="form-control input-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <div className="form-group">
                                        <label
                                            htmlFor="state"
                                            className="control-label"
                                        >
                                            <strong>State</strong>
                                        </label>
                                        <div>
                                            <select
                                                name="state"
                                                value={state.state}
                                                onChange={handleChange}
                                                className="required form-control input-sm state"
                                            >
                                                <option value="">
                                                    Select One
                                                </option>
                                                <option value="AK">AK</option>
                                                <option value="AL">AL</option>
                                                <option value="AR">AR</option>
                                                <option value="AZ">AZ</option>
                                                <option value="CA">CA</option>
                                                <option value="CO">CO</option>
                                                <option value="CT">CT</option>
                                                <option value="DE">DE</option>
                                                <option value="DC">DC</option>
                                                <option value="FL">FL</option>
                                                <option value="GA">GA</option>
                                                <option value="HI">HI</option>
                                                <option value="IA">IA</option>
                                                <option value="ID">ID</option>
                                                <option value="IL">IL</option>
                                                <option value="IN">IN</option>
                                                <option value="KS">KS</option>
                                                <option value="KY">KY</option>
                                                <option value="LA">LA</option>
                                                <option value="ME">ME</option>
                                                <option value="MD">MD</option>
                                                <option value="MA">MA</option>
                                                <option value="MI">MI</option>
                                                <option value="MN">MN</option>
                                                <option value="MO">MO</option>
                                                <option value="MS">MS</option>
                                                <option value="MT">MT</option>
                                                <option value="NC">NC</option>
                                                <option value="ND">ND</option>
                                                <option value="NE">NE</option>
                                                <option value="NH">NH</option>
                                                <option value="NJ">NJ</option>
                                                <option value="NM">NM</option>
                                                <option value="NV">NV</option>
                                                <option value="NY">NY</option>
                                                <option value="OH">OH</option>
                                                <option value="OK">OK</option>
                                                <option value="OR">OR</option>
                                                <option value="PA">PA</option>
                                                <option value="PR">PR</option>
                                                <option value="RI">RI</option>
                                                <option value="SC">SC</option>
                                                <option value="SD">SD</option>
                                                <option value="TN">TN</option>
                                                <option value="TX">TX</option>
                                                <option value="UT">UT</option>
                                                <option value="VA">VA</option>
                                                <option value="VT">VT</option>
                                                <option value="WA">WA</option>
                                                <option value="WI">WI</option>
                                                <option value="WV">WV</option>
                                                <option value="WY">WY</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <div className="form-group">
                                        <label
                                            htmlFor="zip"
                                            className="control-label"
                                        >
                                            <strong>Zip Code</strong>
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                id="zip"
                                                name="zip"
                                                value={state.zip}
                                                onChange={handleChange}
                                                size="10"
                                                maxLength="5"
                                                required="true"
                                                data-parsley-type="digits"
                                                data-parsley-minlength="5"
                                                className="form-control input-sm zip"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-sm-6">
                                    <div className="form-group clearfix">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <label
                                                    htmlFor="area_phone1"
                                                    className="control-label"
                                                >
                                                    <strong>
                                                        Daytime Phone
                                                    </strong>
                                                </label>
                                            </div>
                                            <div className="row">
                                                <fieldset className="form-inline">
                                                    <input
                                                        type="text"
                                                        id="area_phone1"
                                                        name="area_phone1"
                                                        value={
                                                            state.area_phone1
                                                        }
                                                        onChange={handleChange}
                                                        size="3"
                                                        maxLength="3"
                                                        className="form-control phone"
                                                    />
                                                    <input
                                                        type="text"
                                                        id="prefix_phone1"
                                                        name="prefix_phone1"
                                                        value={
                                                            state.prefix_phone1
                                                        }
                                                        onChange={handleChange}
                                                        size="3"
                                                        maxLength="3"
                                                        className="form-control phone"
                                                    />
                                                    <input
                                                        type="text"
                                                        id="suffix_phone1"
                                                        name="suffix_phone1"
                                                        value={
                                                            state.suffix_phone1
                                                        }
                                                        onChange={handleChange}
                                                        size="4"
                                                        maxLength="4"
                                                        className="form-control phone"
                                                    />
                                                    <div id="layerErrorPhone1"></div>
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="form-group">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <label
                                                    htmlFor="area_phone2"
                                                    className="control-label"
                                                >
                                                    <strong>
                                                        Evening Phone{' '}
                                                        <i>
                                                            (for prize
                                                            notification)
                                                        </i>
                                                    </strong>
                                                </label>
                                            </div>
                                            <div className="row">
                                                <fieldset className="form-inline">
                                                    <input
                                                        type="text"
                                                        id="area_phone2"
                                                        name="area_phone2"
                                                        value={
                                                            state.area_phone2
                                                        }
                                                        onChange={handleChange}
                                                        size="3"
                                                        maxLength="3"
                                                        className="form-control phone"
                                                    />
                                                    <input
                                                        type="text"
                                                        id="prefix_phone2"
                                                        name="prefix_phone2"
                                                        value={
                                                            state.prefix_phone2
                                                        }
                                                        onChange={handleChange}
                                                        size="3"
                                                        maxLength="3"
                                                        className="form-control phone"
                                                    />
                                                    <input
                                                        type="text"
                                                        id="suffix_phone2"
                                                        name="suffix_phone2"
                                                        value={
                                                            state.suffix_phone2
                                                        }
                                                        onChange={handleChange}
                                                        size="4"
                                                        maxLength="4"
                                                        className="form-control phone"
                                                    />
                                                    <div id="layerErrorPhone2"></div>
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <label
                                            htmlFor="dob_month"
                                            className="control-label"
                                        >
                                            <strong>Birth Date</strong>
                                        </label>
                                        <fieldset className="form-inline">
                                            <select
                                                name="dob_month"
                                                id="dob_month"
                                                value={state.dob_month}
                                                onChange={handleChange}
                                                className="form-control input-sm"
                                            >
                                                <option value="">Month</option>
                                                <option value="01">
                                                    January
                                                </option>
                                                <option value="02">
                                                    February
                                                </option>
                                                <option value="03">
                                                    March
                                                </option>
                                                <option value="04">
                                                    April
                                                </option>
                                                <option value="05">May</option>
                                                <option value="06">June</option>
                                                <option value="07">July</option>
                                                <option value="08">
                                                    August
                                                </option>
                                                <option value="09">
                                                    September
                                                </option>
                                                <option value="10">
                                                    October
                                                </option>
                                                <option value="11">
                                                    November
                                                </option>
                                                <option value="12">
                                                    December
                                                </option>
                                            </select>
                                            <select
                                                name="dob_day"
                                                id="dob_day"
                                                value={state.dob_day}
                                                onChange={handleChange}
                                                className="form-control input-sm"
                                            >
                                                <option value="">Day</option>
                                                <option value="01">1</option>
                                                <option value="02">2</option>
                                                <option value="03">3</option>
                                                <option value="04">4</option>
                                                <option value="05">5</option>
                                                <option value="06">6</option>
                                                <option value="07">7</option>
                                                <option value="08">8</option>
                                                <option value="09">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                                <option value="21">21</option>
                                                <option value="22">22</option>
                                                <option value="23">23</option>
                                                <option value="24">24</option>
                                                <option value="25">25</option>
                                                <option value="26">26</option>
                                                <option value="27">27</option>
                                                <option value="28">28</option>
                                                <option value="29">29</option>
                                                <option value="30">30</option>
                                                <option value="31">31</option>
                                            </select>
                                            <select
                                                name="dob_year"
                                                id="dob_year"
                                                value={state.dob_year}
                                                onChange={handleChange}
                                                className="form-control input-sm"
                                            >
                                                <option value="">Year</option>
                                                <option value="1900">
                                                    1900
                                                </option>
                                                <option value="1901">
                                                    1901
                                                </option>
                                                <option value="1902">
                                                    1902
                                                </option>
                                                <option value="1903">
                                                    1903
                                                </option>
                                                <option value="1904">
                                                    1904
                                                </option>
                                                <option value="1905">
                                                    1905
                                                </option>
                                                <option value="1906">
                                                    1906
                                                </option>
                                                <option value="1907">
                                                    1907
                                                </option>
                                                <option value="1908">
                                                    1908
                                                </option>
                                                <option value="1909">
                                                    1909
                                                </option>
                                                <option value="1910">
                                                    1910
                                                </option>
                                                <option value="1911">
                                                    1911
                                                </option>
                                                <option value="1912">
                                                    1912
                                                </option>
                                                <option value="1913">
                                                    1913
                                                </option>
                                                <option value="1914">
                                                    1914
                                                </option>
                                                <option value="1915">
                                                    1915
                                                </option>
                                                <option value="1916">
                                                    1916
                                                </option>
                                                <option value="1917">
                                                    1917
                                                </option>
                                                <option value="1918">
                                                    1918
                                                </option>
                                                <option value="1919">
                                                    1919
                                                </option>
                                                <option value="1920">
                                                    1920
                                                </option>
                                                <option value="1921">
                                                    1921
                                                </option>
                                                <option value="1922">
                                                    1922
                                                </option>
                                                <option value="1923">
                                                    1923
                                                </option>
                                                <option value="1924">
                                                    1924
                                                </option>
                                                <option value="1925">
                                                    1925
                                                </option>
                                                <option value="1926">
                                                    1926
                                                </option>
                                                <option value="1927">
                                                    1927
                                                </option>
                                                <option value="1928">
                                                    1928
                                                </option>
                                                <option value="1929">
                                                    1929
                                                </option>
                                                <option value="1930">
                                                    1930
                                                </option>
                                                <option value="1931">
                                                    1931
                                                </option>
                                                <option value="1932">
                                                    1932
                                                </option>
                                                <option value="1933">
                                                    1933
                                                </option>
                                                <option value="1934">
                                                    1934
                                                </option>
                                                <option value="1935">
                                                    1935
                                                </option>
                                                <option value="1936">
                                                    1936
                                                </option>
                                                <option value="1937">
                                                    1937
                                                </option>
                                                <option value="1938">
                                                    1938
                                                </option>
                                                <option value="1939">
                                                    1939
                                                </option>
                                                <option value="1940">
                                                    1940
                                                </option>
                                                <option value="1941">
                                                    1941
                                                </option>
                                                <option value="1942">
                                                    1942
                                                </option>
                                                <option value="1943">
                                                    1943
                                                </option>
                                                <option value="1944">
                                                    1944
                                                </option>
                                                <option value="1945">
                                                    1945
                                                </option>
                                                <option value="1946">
                                                    1946
                                                </option>
                                                <option value="1947">
                                                    1947
                                                </option>
                                                <option value="1948">
                                                    1948
                                                </option>
                                                <option value="1949">
                                                    1949
                                                </option>
                                                <option value="1950">
                                                    1950
                                                </option>
                                                <option value="1951">
                                                    1951
                                                </option>
                                                <option value="1952">
                                                    1952
                                                </option>
                                                <option value="1953">
                                                    1953
                                                </option>
                                                <option value="1954">
                                                    1954
                                                </option>
                                                <option value="1955">
                                                    1955
                                                </option>
                                                <option value="1956">
                                                    1956
                                                </option>
                                                <option value="1957">
                                                    1957
                                                </option>
                                                <option value="1958">
                                                    1958
                                                </option>
                                                <option value="1959">
                                                    1959
                                                </option>
                                                <option value="1960">
                                                    1960
                                                </option>
                                                <option value="1961">
                                                    1961
                                                </option>
                                                <option value="1962">
                                                    1962
                                                </option>
                                                <option value="1963">
                                                    1963
                                                </option>
                                                <option value="1964">
                                                    1964
                                                </option>
                                                <option value="1965">
                                                    1965
                                                </option>
                                                <option value="1966">
                                                    1966
                                                </option>
                                                <option value="1967">
                                                    1967
                                                </option>
                                                <option value="1968">
                                                    1968
                                                </option>
                                                <option value="1969">
                                                    1969
                                                </option>
                                                <option value="1970">
                                                    1970
                                                </option>
                                                <option value="1971">
                                                    1971
                                                </option>
                                                <option value="1972">
                                                    1972
                                                </option>
                                                <option value="1973">
                                                    1973
                                                </option>
                                                <option value="1974">
                                                    1974
                                                </option>
                                                <option value="1975">
                                                    1975
                                                </option>
                                                <option value="1976">
                                                    1976
                                                </option>
                                                <option value="1977">
                                                    1977
                                                </option>
                                                <option value="1978">
                                                    1978
                                                </option>
                                                <option value="1979">
                                                    1979
                                                </option>
                                                <option value="1980">
                                                    1980
                                                </option>
                                                <option value="1981">
                                                    1981
                                                </option>
                                                <option value="1982">
                                                    1982
                                                </option>
                                                <option value="1983">
                                                    1983
                                                </option>
                                                <option value="1984">
                                                    1984
                                                </option>
                                                <option value="1985">
                                                    1985
                                                </option>
                                                <option value="1986">
                                                    1986
                                                </option>
                                                <option value="1987">
                                                    1987
                                                </option>
                                                <option value="1988">
                                                    1988
                                                </option>
                                                <option value="1989">
                                                    1989
                                                </option>
                                                <option value="1990">
                                                    1990
                                                </option>
                                                <option value="1991">
                                                    1991
                                                </option>
                                                <option value="1992">
                                                    1992
                                                </option>
                                                <option value="1993">
                                                    1993
                                                </option>
                                                <option value="1994">
                                                    1994
                                                </option>
                                                <option value="1995">
                                                    1995
                                                </option>
                                                <option value="1996">
                                                    1996
                                                </option>
                                                <option value="1997">
                                                    1997
                                                </option>
                                                <option value="1998">
                                                    1998
                                                </option>
                                                <option value="1999">
                                                    1999
                                                </option>
                                                <option value="2000">
                                                    2000
                                                </option>
                                                <option value="2001">
                                                    2001
                                                </option>
                                                <option value="2002">
                                                    2002
                                                </option>
                                            </select>
                                            <div id="layerErrorDob"></div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 clearfix">
                                    <ul className="password-instructions">
                                        <li>
                                            <em>
                                                Passwords must be between 6 and
                                                16 characters.
                                            </em>
                                        </li>
                                        <li>
                                            <em>
                                                Password must contain at least
                                                (1) letter and (1) number.
                                            </em>
                                        </li>
                                        <li>
                                            <em>
                                                Passwords are case sensitive.
                                            </em>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="form-group">
                                        <label
                                            htmlFor="password"
                                            className="control-label"
                                        >
                                            <strong>Password</strong>
                                        </label>
                                        <div>
                                            <input
                                                type="password"
                                                id="password"
                                                name="password"
                                                value={state.password}
                                                onChange={handleChange}
                                                size="20"
                                                maxLength="16"
                                                required="true"
                                                className="form-control input-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="form-group">
                                        <label
                                            htmlFor="verify_password"
                                            className="control-label"
                                        >
                                            <strong>Confirm Password</strong>
                                        </label>
                                        <div>
                                            <input
                                                type="password"
                                                id="verify_password"
                                                name="verify_password"
                                                value={state.verify_password}
                                                onChange={handleChange}
                                                size="20"
                                                maxLength="16"
                                                required="true"
                                                className="form-control input-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <div className="optins small">
                                            <div className="checkbox">
                                                <label
                                                    htmlFor="optin2"
                                                    className="optin-label"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="optin2"
                                                        name="optin2"
                                                        value={state.optin2}
                                                        onChange={handleChange}
                                                        checked={state.optin2}
                                                    />
                                                    YES! I want free iLottery
                                                    games and cash match bonus
                                                    offers!
                                                </label>
                                            </div>
                                            <div className="checkbox">
                                                <label
                                                    htmlFor="optin1"
                                                    className="optin-label"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="optin1"
                                                        name="optin1"
                                                        required="true"
                                                        value={state.optin1}
                                                        onChange={handleChange}
                                                        checked={state.optin1}
                                                    />
                                                    <strong>
                                                        <p>
                                                            By checking this
                                                            box, I certify that
                                                            I am 18 years old or
                                                            older.
                                                        </p>
                                                    </strong>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pad-top-2em text-center">
                                <input
                                    type="submit"
                                    id="submit"
                                    name="submit"
                                    value="Submit"
                                    className="btn btn-theme red-theme"
                                />
                                &nbsp;
                                {/* {resetButton()} */}
                                &nbsp;
                                {/* {cancelButton()} */}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default RegisterForm;
